if (!customElements.get('relay-real-world-carousel')) {
  customElements.define('relay-real-world-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('.rrw-slide'));
      this.viewport = this.querySelector('.rrw-viewport');
      this.position = this.querySelector('[data-position]');
      this.controls = this.querySelector('.rrw-controls');
      if (!this.slides.length || !this.viewport || !this.controls) return;
      this.index = 0;
      this.touch = null;
      this.controls.hidden = this.slides.length < 2;
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), { signal });
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const destinations = { ArrowLeft: this.index - direction, ArrowRight: this.index + direction, Home: 0, End: this.slides.length - 1 };
        if (Object.hasOwn(destinations, event.key)) {
          event.preventDefault();
          this.show(destinations[event.key]);
        }
      }, { signal });
      this.viewport.addEventListener('touchstart', event => {
        this.touch = null;
        if (event.target.closest('video, button, a, summary, input, select, textarea') || event.touches?.length > 1) return;
        const touch = event.changedTouches[0];
        this.touch = { x: touch.clientX, y: touch.clientY };
      }, { passive: true, signal });
      this.viewport.addEventListener('touchend', event => {
        if (!this.touch) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - this.touch.x;
        const dy = touch.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.show(this.index + (dx < 0 ? direction : -direction));
        }
      }, { passive: true, signal });
      this.viewport.addEventListener('touchcancel', () => { this.touch = null; }, { passive: true, signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, { signal });
      this.show(0);
      this.dataset.ready = 'true';
    }
    show(destination) {
      this.slides[this.index]?.querySelectorAll('video').forEach(video => video.pause());
      this.index = (destination + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      this.position.textContent = this.dataset.positionTemplate.replace('__current__', this.index + 1).replace('__total__', this.slides.length);
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.controller?.abort();
      this.controller = null;
    }
  });
}
